// extracted by css-extract-rspack-plugin
export default {"media":"ShowMoreItem_media__oIgiR"};